import React from 'react';
import { Badge } from '../../../../components/ui';
import { Icon } from '../../../../components/icons';
import { BRAND, BRAND_LIGHT, getThemeColors } from '../../../../lib/theme';
import type { DashboardData } from '../types';

interface KpiWidgetProps {
  mode: 'full' | 'summary';
  dark: boolean;
  data: DashboardData | null;
  tr: (k: string) => string;
}

export function KpiWidget({ mode, dark, data, tr }: KpiWidgetProps) {
  const t = getThemeColors(dark);
  const stats = data ? [
    { labelKey: 'dashboard.widget.kpi.new_contacts',  value: data.badges.new_users,             tone: 'warning' as const, ic: 'Inbox'     as const },
    { labelKey: 'dashboard.widget.kpi.urgent',         value: data.badges.urgent_users,           tone: 'error'   as const, ic: 'Heart'     as const },
    { labelKey: 'dashboard.widget.kpi.to_confirm',     value: data.badges.confirmation_messages, tone: 'warning' as const, ic: 'Users'     as const },
    { labelKey: 'dashboard.widget.kpi.proof_of_service', value: data.badges.leistungsnachweise,  tone: 'info'    as const, ic: 'Dashboard' as const },
  ] : [];

  if (mode === 'summary') {
    return (
      <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', alignItems: 'center' }}>
        {stats.map(s => (
          <div key={s.labelKey} style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
            <Badge tone={s.tone} dark={dark}>{s.value}</Badge>
            <span style={{ fontSize: 11, color: t.muted }}>{tr(s.labelKey)}</span>
          </div>
        ))}
        {!data && <span style={{ fontSize: 12, color: t.muted }}>{tr('dashboard.widget.loading')}</span>}
      </div>
    );
  }

  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', gap: 10 }}>
      {stats.map(s => {
        const Ic = Icon[s.ic] as React.ComponentType<{ c: string }>;
        return (
          <div key={s.labelKey} style={{
            padding: 12, background: dark ? '#1a1f2b' : '#f9fafb',
            borderRadius: 12, border: `1px solid ${t.borderSoft}`,
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8 }}>
              <div style={{ width: 32, height: 32, borderRadius: 8, background: BRAND_LIGHT, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Ic c={BRAND} />
              </div>
              <Badge tone={s.tone} dark={dark}>live</Badge>
            </div>
            <div style={{ fontSize: 22, fontWeight: 700, color: t.heading }}>{s.value ?? '—'}</div>
            <div style={{ fontSize: 11, color: t.muted, marginTop: 2 }}>{tr(s.labelKey)}</div>
          </div>
        );
      })}
      {!data && (
        <div style={{ fontSize: 12, color: t.muted, gridColumn: '1 / -1' }}>{tr('dashboard.widget.loading')}</div>
      )}
    </div>
  );
}
